<template>
  <div class="expand">
    <transition name="expand" @enter="enter" @leave="leave" @after-enter="afterEnter" @after-leave="afterLeave">
      <div class="expand-target" v-if="isOpen">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
/* eslint-disable no-param-reassign */
import Vue from "vue";

interface Methods {
  enter: (el: HTMLElement) => void;
  leave: (el: HTMLElement) => void;
  afterEnter: (el: HTMLElement) => void;
  afterLeave: (el: HTMLElement) => void;
  nextFrame: (fn: any) => void;
}

interface Props {
  isOpen: boolean;
}

export default Vue.extend<unknown, Methods, unknown, Props>({
  props: {
    isOpen: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    enter(el) {
      el.style.overflow = "hidden";
      el.style.height = "0";

      this.nextFrame(() => {
        el.style.height = `${el.scrollHeight}px`;
      });
    },
    leave(el) {
      el.style.overflow = "hidden";
      el.style.height = `${el.scrollHeight}px`;

      this.nextFrame(() => {
        el.style.height = "0";
      });
    },
    afterEnter(el) {
      el.style.height = "";
      el.style.overflow = "";
    },
    afterLeave(el) {
      el.style.height = "";
      el.style.overflow = "";
    },
    nextFrame(fn) {
      // NOTE: 以下参考にした
      // https://note.com/noliaki/n/n6e3a60748c11
      window.requestAnimationFrame(() => window.requestAnimationFrame(fn));
    },
  },
});
</script>

<style lang="scss" scoped>
.expand {
  &-target {
    transition: height 0.4s ease-in-out;
    overflow: hidden;
  }

  // transitionの[name]-enter-activeで開始animationを設定できる
  &-enter-active {
    animation-duration: 1s;
    animation-fill-mode: both;
    animation-name: expand-anime;
  }

  // transitionの[name]-leave-activeで開始animationを設定できる
  &-leave-active {
    animation-duration: 0.5s;
    animation-fill-mode: both;
    animation-name: contract-anime;
  }
}

@keyframes expand-anime {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes contract-anime {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
</style>
